module.exports = __webpack_public_path__ + "img/dostartu-podcast-logo.be77a1dd.svg";